import axios, { AxiosResponse } from 'axios'
import { firebaseConfig } from '@dataplace.ai/services'
import { getCookieWithoutJSON } from '../utils'

export const checkSessionRequest = ():Promise<AxiosResponse<string>> => axios.get<string>(`${firebaseConfig.AUTH_SESSION_ENDPOINT}/check`, {
  headers: {
    Authorization: getCookieWithoutJSON('__session'),
  },
})
